import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M14.632 6.3l-.933-.932L10 9.067l-3.7-3.7-.932.934L9.067 10l-3.7 3.7.934.932L10 10.933l3.7 3.7.932-.934L10.933 10l3.7-3.7z" fill="#54585D" fillOpacity=".6" /></svg>);